import { render, staticRenderFns } from "./CalendarItem.vue?vue&type=template&id=113b8d90&scoped=true"
import script from "./CalendarItem.vue?vue&type=script&lang=js"
export * from "./CalendarItem.vue?vue&type=script&lang=js"
import style0 from "./CalendarItem.vue?vue&type=style&index=0&id=113b8d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113b8d90",
  null
  
)

export default component.exports